import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, roleHome } from "@/context/AuthContext";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Internships from "@/pages/Internships";
import InternshipDetail from "@/pages/InternshipDetail";
import Projects from "@/pages/Projects";
import ProposeProject from "@/pages/ProposeProject";
import FacultyDirectory from "@/pages/FacultyDirectory";
import FacultyDetail from "@/pages/FacultyDetail";
import CareerPaths from "@/pages/CareerPaths";
import Applications from "@/pages/Applications";
import ProfilePage from "@/pages/ProfilePage";
import Notifications from "@/pages/Notifications";
import Support from "@/pages/Support";
import FacultyPortal from "@/pages/FacultyPortal";
import OrgPortal from "@/pages/OrgPortal";
import AdminPortal from "@/pages/AdminPortal";

function Protected({ roles, children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="grid min-h-screen place-items-center bg-background" data-testid="auth-loading">
                <p className="text-sm text-muted-foreground">Loading...</p>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role)) return <Navigate to={roleHome(user.role)} replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/auth/callback" element={<AuthCallback />} />
                        <Route path="/internships" element={<Internships />} />
                        <Route path="/internships/:id" element={<InternshipDetail />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/faculty" element={<FacultyDirectory />} />
                        <Route path="/faculty/:id" element={<FacultyDetail />} />
                        <Route path="/career-paths" element={<CareerPaths />} />
                        <Route path="/support" element={<Support />} />
                        <Route path="/dashboard" element={<Protected roles={["student"]}><Dashboard /></Protected>} />
                        <Route path="/applications" element={<Protected roles={["student"]}><Applications /></Protected>} />
                        <Route path="/profile" element={<Protected roles={["student"]}><ProfilePage /></Protected>} />
                        <Route path="/propose-project" element={<Protected roles={["student"]}><ProposeProject /></Protected>} />
                        <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
                        <Route path="/faculty-portal" element={<Protected roles={["faculty"]}><FacultyPortal /></Protected>} />
                        <Route path="/org-portal" element={<Protected roles={["organization"]}><OrgPortal /></Protected>} />
                        <Route path="/admin" element={<Protected roles={["admin"]}><AdminPortal /></Protected>} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </AuthProvider>
        </div>
    );
}

export default App;
